import {DensityModification, Material, PartData} from "./generated/types";
import {Density, MaterialAttributes} from "./types";

/**
 * Round to two fractions digits away from zero.
 * @param num
 */
function roundToTwoAwayFromZero(num: number) {
  return +(Math.round(num + ("e+2" as any)) + "e-2");
}

function getDensityOfMaterial(part: PartData, material: MaterialAttributes): Density | null {

  if (part.densityModification === DensityModification.Foamt && material.densityFoamed != null) {
    return material.densityFoamed;
  }

  if (part.densityModification === DensityModification.Filled && material.densityFilled != null) {
    return material.densityFilled;
  }

  return material.density;
}

export function calculateDensity(materials: Record<Material, MaterialAttributes>, part: PartData) {

  if (!part.composites || part.composites.length === 0) {

    if (part.material == null) {
      return null;
    }

    const material = materials[part.material];
    if (material == null) {
      return null;
    }

    return getDensityOfMaterial(part, material);
  }

  let low = 0;
  let high = 0;

  for (let composite of part.composites) {

    if (composite.material == null) {
      return null;
    }

    const material = materials[composite.material];
    if (material == null) {
      return null;
    }

    if (composite.fraction == null) {
      return null;
    }

    const density = getDensityOfMaterial(part, material);
    if (density == null) {
      return null;
    }

    low += composite.fraction * density.low;
    high += composite.fraction * density.high;
  }

  return {
    low: roundToTwoAwayFromZero(low),
    high: roundToTwoAwayFromZero(high)
  };
}
